export function selectDisplayLeftDrawer(state) {
    return state.display.displayLeftDrawer;
}
